// extracted by mini-css-extract-plugin
export default {"mainContainer":"Admin_mainContainer__GRHdQ","row":"Admin_row__1hlTd","column":"Admin_column__2iNWa","label":"Admin_label__YK+Fu","flexWraper":"Admin_flexWraper__nsyF7"};